<template>
  <div class="outras-praticas">
    <div class="info-table">
      <div class="info-table-item download-right">
        <b-dropdown variant="secondary" size="sm" class="ml-2 dropdown-files">
          <template #button-content>
            <i class="icofont-download"></i> Exportar
          </template>
          <b-dropdown-item @click="generatePdf">
            <i class="icofont-file-pdf"></i> PDF
          </b-dropdown-item>
          <b-dropdown-item @click="exportarXlsPersonalizado">
            <i class="icofont-file-excel"></i> XLS
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <v-app class="app-tabela">
      <div class="box" style="margin-top: 0px">
        <v-card class="tabela">
          <v-card-title>
            <v-text-field 
              v-model="search" 
              append-icon="mdi-magnify" 
              label="Buscar por INEP, Escola ou Equipe" 
              class="input-bottom"
              single-line 
              hide-details 
            />
          </v-card-title>
          <v-data-table 
            :mobile-breakpoint="0" 
            @pagination="getPagination" 
            :page="currentPage"
            :server-items-length="filteredRecords.length"
            :footer-props="{ itemsPerPageText: '', 'items-per-page-options': [10], 'disable-items-per-page': true }" 
            :loading="loading" 
            loading-text="Carregando, por favor, espere" 
            :headers="dynamicHeaders" 
            :items="currentPageRecords" 
            :single-expand="true" 
            :expanded.sync="expanded" 
            item-key="id" 
            :show-expand="true" 
            class="elevation-1"
          >
            <template v-slot:[`footer.page-text`]="items">
              <div class="info-table-item tabela-esus-pec">
                <b>Fonte:</b> e-SUS PEC, {{ ultimaAtualizacao }}
              </div>
              <span class="paginacao">
                {{ currentPageTotal }} de {{ overallTotal }} atividades
              </span>
            </template>

            <template v-slot:expanded-item="{ item }">
              <td colspan="9" class="table-expand-details">
                <div class="expanded-content">
                  <table class="table table-expand">
                    <thead>
                      <tr>
                        <th>Data</th>
                        <th>Profissional</th>
                        <th>CBO</th>
                        <th>Participantes</th>
                        <th>Atividades</th>
                        <th class="export-col">
                          <b-dropdown size="sm" class="dropdown-files">
                            <template #button-content>
                              <i class="icofont-download"></i> Exportar
                            </template>
                            <b-dropdown-item @click="exportTeamData(item)">
                              <i class="icofont-file-pdf"></i> PDF
                            </b-dropdown-item>
                            <b-dropdown-item @click="exportTeamXls(item)">
                              <i class="icofont-file-excel"></i> XLS
                            </b-dropdown-item>
                          </b-dropdown>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(detail, index) in item.details" :key="index">
                        <td>{{ formatDate(detail.data) }}</td>
                        <td>{{ detail.no_profissional }}</td>
                        <td>{{ detail.co_cbo }}</td>
                        <td>{{ detail.nu_participantes }}</td>
                        <td>{{ detail.tipo_atividade }}</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </template>

            <template v-slot:progress>
              <v-progress-linear color="blue" :height="10" indeterminate />
            </template>
            <template v-slot:no-data>
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada.</b>
              </div>
            </template>
            <template v-slot:no-results>
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada.</b>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-app>
  </div>
</template>

<script>
import * as Functions from './functions.js'
import store from '@/store/store'

export default {
  name: 'OutrasPraticas',
  data() {
    return {
      search: '',
      loading: false,
      expanded: [],
      currentPage: 1,
      itemsPerPage: 10,
      currentPageRecords: [],
      records: [],
      ultimaAtualizacao: this.$store.getters['getUltimaAtualizacao'],
      mainExportName: `PSE_Outras_Praticas_${store.state.cidade}_${new Date().toISOString().split('T')[0]}`,
      dynamicHeaders: [
        { text: 'INEP', value: 'inep' },
        { text: 'Escola', value: 'no_escola' },
        { text: 'Equipe', value: 'no_equipe' },
        { text: 'Saúde Física', value: 'qtd_atvds_saude_fisica' },
        { text: 'Saúde Bucal', value: 'qtd_atvds_saude_bucal' },
        { text: 'Saúde Auditiva', value: 'qtd_atvds_saude_auditiva' },
        { text: 'Saúde Ocular', value: 'qtd_atvds_saude_ocular' },
        { text: 'Estudantes', value: 'qtd_estimado_alunos' },
        { text: '', value: 'data-table-expand' }
      ],
      exportXlsFields: [
        { key: 'inep', label: 'INEP' },
        { key: 'no_escola', label: 'Escola' },
        { key: 'no_equipe', label: 'Equipe' },
        { key: 'qtd_atvds_saude_fisica', label: 'Saúde Física' },
        { key: 'qtd_atvds_saude_bucal', label: 'Saúde Bucal' },
        { key: 'qtd_atvds_saude_auditiva', label: 'Saúde Auditiva' },
        { key: 'qtd_atvds_saude_ocular', label: 'Saúde Ocular' },
        { key: 'qtd_estimado_alunos', label: 'Estudantes' }
      ]
    }
  },
  computed: {
    filteredRecords() {
      const searchLower = (this.search || '').toLowerCase();
      if (!searchLower) return this.records;
      return this.records.filter(record =>
        ((record.inep || '').toString().toLowerCase().includes(searchLower)) ||
        ((record.no_escola || '').toLowerCase().includes(searchLower)) ||
        ((record.no_equipe || '').toLowerCase().includes(searchLower))
      );
    },
    currentPageTotal() {
      return this.currentPageRecords.reduce((total, record) => {
        const fisica = Number(record.qtd_atvds_saude_fisica) || 0;
        const bucal = Number(record.qtd_atvds_saude_bucal) || 0;
        const auditiva = Number(record.qtd_atvds_saude_auditiva) || 0;
        const ocular = Number(record.qtd_atvds_saude_ocular) || 0;
        const sumRecord = fisica + bucal + auditiva + ocular;
        return total + sumRecord;
      }, 0);
    },
    overallTotal() {
      return this.filteredRecords.reduce((total, record) => {
        const fisica = Number(record.qtd_atvds_saude_fisica) || 0;
        const bucal = Number(record.qtd_atvds_saude_bucal) || 0;
        const auditiva = Number(record.qtd_atvds_saude_auditiva) || 0;
        const ocular = Number(record.qtd_atvds_saude_ocular) || 0;
        const sumRecord = fisica + bucal + auditiva + ocular;
        return total + sumRecord;
      }, 0);
    }
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const response = await this.$api.get(`/app/pse/${store.state.cod_ibge}?tipo=outras-praticas`)
        if (response && response.data) {
          this.records = response.data.map((item, index) => {
            let details = []
            if (item.dados_atvdds) {
              try {
                details = JSON.parse(item.dados_atvdds)
              } catch (e) {
                console.error('Erro ao parsear dados_atvdds:', e)
                details = []
              }
            }
            
            return {
              id: index,
              ...item,
              details: details
            }
          })
          this.updateCurrentPageRecords()
        }
      } catch (error) {
        console.error('Erro ao buscar dados:', error)
      } finally {
        this.loading = false
      }
    },
    getPagination({ page, itemsPerPage }) {
      this.currentPage = page
      this.itemsPerPage = itemsPerPage
      this.updateCurrentPageRecords()
    },
    updateCurrentPageRecords() {
      const start = (this.currentPage - 1) * this.itemsPerPage
      const end = start + this.itemsPerPage
      this.currentPageRecords = this.filteredRecords.slice(start, end)
      
      this.currentPageRecords.forEach((record, index) => {
        if (!record.id) {
          record.id = start + index
        }
      })
    },
    formatDate(date) {
      if (!date) return '';
      if (date.includes('-')) {
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      }
      return new Date(date).toLocaleDateString('pt-BR');
    },
    exportTeamData(item) {
      Functions.exportTeamPdf(item) 
    },
    exportTeamXls(item) {
      if (!item.details || item.details.length === 0) {
        console.error('Nenhum detalhe disponível para exportação XLS');
        alert('Nenhum detalhe disponível para exportação XLS');
        return;
      }
      // Mapear dados dos detalhes
      const dados = item.details.map(detail => ({
        Data: this.formatDate(detail.data),
        Profissional: detail.no_profissional,
        CBO: detail.co_cbo,
        Participantes: detail.nu_participantes,
        Atividades: detail.tipo_atividade
      }))
      // Definir ordem das colunas para detalhes
      const teamColumnOrder = [
        'Data',
        'Profissional',
        'CBO',
        'Participantes',
        'Atividades'
      ];
      const cidade = store.state.cidade || "";
      const titulo = "PSE - Outras Práticas";
      const descricao_secretaria = "SECRETARIA MUNICIPAL DE SAÚDE";
      const descricao = "Detalhes das Atividades Coletivas da Escola";
      const dataAtual = new Date().toLocaleDateString();
      const subtitulo = `INEP: ${item.inep}\nEscola: ${item.no_escola || ''}\nEquipe: ${item.no_equipe || ''}`;
      const nomeArquivo = `PSE_Outras_Praticas_${item.no_escola || 'Escola'}_${item.inep}_${cidade}`;

      Functions.exportarXlsCustomizado(
        dados,
        nomeArquivo,
        cidade,
        titulo,
        descricao_secretaria,
        descricao,
        dataAtual,
        subtitulo,
        teamColumnOrder
      );
    },
    exportarXlsPersonalizado() {
      const data = this.filteredRecords.map(item => ({
        INEP: item.inep,
        Escola: item.no_escola,
        Equipe: item.no_equipe,
        'Saúde Física': item.qtd_atvds_saude_fisica,
        'Saúde Bucal': item.qtd_atvds_saude_bucal,
        'Saúde Auditiva': item.qtd_atvds_saude_auditiva,
        'Saúde Ocular': item.qtd_atvds_saude_ocular,
        Estudantes: item.qtd_estimado_alunos
      }))

      const cidade = store.state.cidade || "Cidade";
      const titulo = "PSE - Outras Práticas";
      const descricao_secretaria = "SECRETARIA MUNICIPAL DE SAÚDE";
      const descricao = "Atividades Coletivas (Outras Práticas) por escola";
      const dataAtual = new Date().toLocaleDateString();
      const subtitulo = "Atividades coletivas por escola"; // Subtítulo genérico
      const nomeArquivo = this.mainExportName;
      const columnOrder = this.exportXlsFields.map(f => f.label)

      Functions.exportarXlsCustomizado(
        data,
        nomeArquivo,
        cidade,
        titulo,
        descricao_secretaria,
        descricao,
        dataAtual,
        subtitulo,
        columnOrder
      );
    },
    generatePdf() {
      const mainTableHeaders = this.exportXlsFields.map(f => f.label);
      const mainTableKeys = this.exportXlsFields.map(f => f.key);
      const pdfTitle = 'PSE - Outras Práticas';

      Functions.generatePdf(this.filteredRecords, mainTableHeaders, mainTableKeys, pdfTitle)
        .then(() => {
          this.$root.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', { position: 'topRight' });
        })
        .catch((error) => {
          console.error('Erro ao gerar PDF no componente:', error);
          this.$root.$toast.error('ERRO AO GERAR PDF!', 'Erro:', { position: 'topRight' });
        });
    }
  },
  created() {
    this.fetchData()
  },
  watch: {
    search() {
      this.currentPage = 1
      this.updateCurrentPageRecords()
    }
  }
}
</script>

<style scoped>
.outras-praticas {
  padding: 20px 0;
}

.info-table {
  display: flex;
  justify-content: flex-end;
  margin-bottom: -10px;
}

.app-tabela {
  background: transparent !important;
}

.box {
  background: #fff;
  border-radius: 5px;
}

.tabela {
  width: 100%;
}

.input-bottom {
  margin-bottom: 0;
}

.table-expand-details {
  background-color: #f8f9fa;
  padding: 0;
}

.expanded-content {
  padding: 10px 20px;
}

.table-expand {
  margin: 20px 0;
  width: 100%;
  table-layout: auto;
}

.export-col {
  width: 100px;
  text-align: right;
}

.export-col .dropdown-files {
  display: inline-block;
}

.export-col .dropdown-files .btn {
  white-space: nowrap;
}

.tabela-esus-pec {
  margin-right: 20px;
}

.paginacao {
  margin-left: 20px;
}

.dropdown-files {
  margin-left: 10px;
}

.v-data-table {
  overflow-x: auto;
}

.v-data-table ::v-deep .v-data-table__wrapper {
  border-radius: 5px;
  overflow-x: auto;
  box-shadow: 0 1px 5px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 2px 0 rgba(0,0,0,.12);
}

.v-data-table ::v-deep .v-data-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}
</style>